/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_L3Inputs */

const en_landing_guide_s3_l3 = /** @type {(inputs: Landing_Guide_S3_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product photography: change a prop, a colour or the background behind a hero product in a few precise passes.`)
};

const zh_landing_guide_s3_l3 = /** @type {(inputs: Landing_Guide_S3_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品摄影：几轮精准修改，就能替换道具、颜色或主产品背后的背景。`)
};

/**
* | output |
* | --- |
* | "Product photography: change a prop, a colour or the background behind a hero product in a few precise passes." |
*
* @param {Landing_Guide_S3_L3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_l3 = /** @type {((inputs?: Landing_Guide_S3_L3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_L3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_l3(inputs)
	return zh_landing_guide_s3_l3(inputs)
});
export { landing_guide_s3_l3 as "landing.guide.s3_l3" }